import { useAppHeaderViewModel } from 'NavigationHelpers';
import useIsMobileMixin from 'StudentNetwork/react/useIsMobileMixin';

const DEFAULT_SPACING_BOTTOM_SPACING = 'h-12';
const DEFAULT_SPACING_BOTTOM_SPACING_MOBILE = 'h-21';

type SpacingOverride = `h-${string}`;

export const useTutorBotBottomSpacing = (overrideWhenMobileMenuHidden?: SpacingOverride) => {
    const AppHeaderViewModel = useAppHeaderViewModel();
    const { isMobile } = useIsMobileMixin();

    // When on desktop and in the lesson player bot, we need a bottom margin that
    // matches the value in show_frame_player.scss#.return-to-screen-wrapper (see comment there)
    // so that the buttons on both sides of the screen line up. In other contexts (i.e. BotPage)
    // this particular spacing isn't so important, but it works fine
    if (!isMobile) return DEFAULT_SPACING_BOTTOM_SPACING;

    // When the mobile menu is showing, we need to add extra bottom spacing
    // in the mobile breakpoint to pull the input box above the menu.
    if (!AppHeaderViewModel.hideMobileMenu) return DEFAULT_SPACING_BOTTOM_SPACING_MOBILE;

    // When we're on mobile and not showing the mobile menu, the bottom spacing is
    // not tied to anything else, so each UI component can do its own thing
    return overrideWhenMobileMenuHidden ?? DEFAULT_SPACING_BOTTOM_SPACING;
};
